import $ from 'jquery'

$(document).ready(function () {
    // Add an event listener to the form submission
    document.addEventListener('wpcf7submit', function(event) {
        // Attempt to select the form element
        var form = document.querySelector('.wpcf7-form');

        // Check if the form element was found
        if (form) {
            // Define two arrays of field names for each group
            var requiredFieldsGroup1 = ['name', 'company'];
            var requiredFieldsGroup2 = ['phone', 'email'];

            // Initialize flags to check if at least one field is filled in each group
            var group1Filled = false;
            var group2Filled = false;

            // Check if at least one field is filled in the first group
            for (var i = 0; i < requiredFieldsGroup1.length; i++) {
                var fieldName = requiredFieldsGroup1[i];
                var fieldInput = form.querySelector('[name="' + fieldName + '"]');
                if (fieldInput && fieldInput.value.trim() !== '') {
                    group1Filled = true;
                    break;
                }
            }

            // Check if at least one field is filled in the second group
            for (var j = 0; j < requiredFieldsGroup2.length; j++) {
                var fieldName = requiredFieldsGroup2[j];
                var fieldInput = form.querySelector('[name="' + fieldName + '"]');
                if (fieldInput && fieldInput.value.trim() !== '') {
                    group2Filled = true;
                    break;
                }
            }

            // If no fields are filled in either group, prevent form submission and display an error message
            if (!group1Filled) {
                event.preventDefault();
                // Display error messages for each group
                document.getElementById('name-error').textContent = 'Please fill out name or company name.';
                document.getElementById('name-error-2').textContent = 'Please fill out name or company name.';
            } else {
                document.getElementById('name-error').textContent = '';
                document.getElementById('name-error-2').textContent = '';
            }
            
            if (!group2Filled) {
                event.preventDefault();
                document.getElementById('contact-error').textContent = 'Please fill out phone or email.';
                document.getElementById('contact-error-2').textContent = 'Please fill out phone or email.';
            } else {
                document.getElementById('contact-error').textContent = '';
                document.getElementById('contact-error-2').textContent = '';
            }
        } else {
            console.error('Form element not found.'); // Log an error if the form element is not found
        }

       
    }, false);

});


// WEBPACK FOOTER //
// ./resources/assets/js/partials/forms.js